<template>
	<div class="row-user">
		<div class="user-initials">{{ Helper.get_user_initials(user) }}</div>
		<div class="user-name">{{ user.prenom }} {{ user.nom }}</div>
		<div class="user-description">
		</div>
		<div v-if="show_user_tooltip" class="user-details">
			<div class="user-detail-name">{{ user.prenom }} {{ user.nom }}</div>
			<div v-if="user.email" class="user-detail-info"><icon file="mail" :size="16" /> <a :href="'mailto:' + user.email">{{ user.email }}</a></div>
		</div>
		<div v-if="!isreadonly" class="user-remove" @click="remove()" title="Retirer cette personne"><icon file="minus" :size="16" /></div>

	</div>

</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "form-study",
	data: function () {
		return {
			
		};
	},
	props: [ "user", "show_user_tooltip" ,"readonly"],
	computed: {
		...mapGetters([ "app", "study" ]),
		isreadonly: function () {
			return this.readonly =="true";
		},
	},
	methods: {
		remove: function () {
			this.$emit("remove");
		}
	},
	mounted: function () {
		
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/app'
@import '../../../assets/css/grid'
@import '../../../assets/css/ui'


.row-user
	display block
	height 64px
	padding 8px
	margin 0 0 8px 0
	border-radius radius
	box-shadow inset 0 0 0 2px #eee
	line-height 24px
	white-space nowrap
	&:hover
		box-shadow inset 0 0 0 2px #ddd
		.user-remove
			opacity 1
		.user-details
			display block
	.user-initials
		float left
		width 48px
		height 48px
		display flex
		align-items center
		justify-content center
		margin 0 8px 0 0
		border-radius 100%
		background-color #eee
		font-weight 500
		color dark
		text-transform uppercase
	.user-name
		display block
		margin-left 56px
		font-weight 500
		transform translateY(2px)
	.user-description
		display block
		margin-left 56px
		transform translateY(-2px)
		color lighten(dark, 50%)
		font-size 12px
		span
			display inline-block
			margin 0 16px 0 0
			> .icon
				float left
				margin 4px 4px 0 0
		a
			text-decoration underline
			&:hover
				text-decoration none
	.user-remove
		opacity 0
		position absolute
		right -4px
		top -4px
		width 24px
		height 24px
		display flex
		align-items center
		justify-content center
		background-color red
		border-radius 100%
		box-shadow 0 0 0 4px #fff
		cursor pointer
		color #fff
		text-align center
		&:hover
			background-color darken(red, 10%)
		&:active
			background-color darken(red, 20%)
			transform translateY(1px)
		.icon
			display block
	
	.user-details
		display none
		position absolute
		left calc(100% + 12px)
		top 50%
		width auto
		padding 16px
		transform translateY(-50%)
		background-color #fff
		border-radius radius
		border 2px solid #ddd
		&:before
			content ''
			position absolute
			top 0
			left -14px
			width 16px
			height 100%
		&:after
			content ''
			position absolute
			left -8px
			top 50%
			margin-top -8px
			width 0
			height 0
			border-style solid
			border-width 8px 8px 8px 0
			border-color transparent #ddd transparent transparent
		
		.user-detail-name
			font-weight 500
		
		.user-detail-info
			display block
			white-space nowrap
			padding 2px 0
			line-height 24px
			color lighten(dark, 50%)
			> .icon
				display inline-block
				margin 0px 8px 0 0
			a
				text-decoration underline
				&:hover
					text-decoration none

</style>